var _path, _rect, _rect2, _rect3, _path2, _polygon;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgResume(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M333.205,34.213L330.799,0L9.546,22.591l30.317,431.118l44.011-3.095V512h322.046v-35.276l50.265,5.413l46.27-429.698 L333.205,34.213z M83.874,420.519l-16.17,1.137L41.599,50.432l261.359-18.38l3.359,47.765H83.874V420.519z M375.9,481.979H113.895 V109.838H375.9V481.979z M429.552,449.073l-23.631-2.545V79.817h-69.508l-1.068-15.18l134.049,14.434L429.552,449.073z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 195.796,
    height: 30.021,
    x: 147.003,
    y: 296.746
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 195.796,
    height: 30.021,
    x: 147.003,
    y: 350.143
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 195.796,
    height: 30.021,
    x: 147.003,
    y: 403.54
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M201.384,229.293c-13.238,0-22.154-9.186-22.154-23.64s8.915-23.64,22.154-23.64c8.511,0,15.13,4.053,20.668,11.078 l20.128-17.966c-9.321-12.157-23.911-18.912-42.418-18.912c-30.394,0-52.684,20.398-52.684,49.442s22.289,49.442,52.684,49.44 c18.508,0,33.097-6.754,42.418-18.912l-20.128-17.966C216.514,225.24,209.895,229.293,201.384,229.293z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "321.075 158.373 297.975 213.624 275.415 158.373 241.102 158.373 281.088 252.934 312.429 252.934 352.414 158.373"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResume);
export default __webpack_public_path__ + "static/media/resume.d3cc10343a59db660548b3700671da0b.svg";
export { ForwardRef as ReactComponent };